const apiUrl = process.env.REACT_APP_API_URL;

export const getInventoryReports = async(categoryId, SubcategoryId, StatusId) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/items/getInventoryReport1/${categoryId}/${SubcategoryId}/${StatusId}`;
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json();
    } catch (error) {
        return [];
    }
}